import React from 'react';
import PropTypes from 'prop-types';
import { StandardEventSummary } from './StandardEventSummary';
import { UpsellEventSummary } from './UpsellEventSummary';
import './EventsSummary.scss';

/**
 * ? It might be a bug in Angular using the condition `event.UpsellItem`
 * which is not on the payload, hence always falling to the NOT condition
 * and displaying StandartEvent always. In the same way, I am displaying
 * StandardEvent display only for all - to display the same as PROD
 */
export const EventsSummary = (props) => {
  const { performanceTicket, allowRemove, stepName } = props;

  let event;
  if (performanceTicket?.UpsellItem) {
    event = (
      <UpsellEventSummary
        performanceTicket={performanceTicket}
        allowRemove={allowRemove}
        stepName={stepName}
      />
    );
  } else {
    event = (
      <StandardEventSummary
        performanceTicket={performanceTicket}
        allowRemove={allowRemove}
        stepName={stepName}
      />
    );
  }

  return event;
};

EventsSummary.propTypes = {
  performanceTicket: PropTypes.object,
  allowRemove: PropTypes.bool,
  stepName: PropTypes.string,
};
